import {
  EnvironmentProviders,
  inject,
  Injectable,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { UserProfileService } from '@volo/ngx-lepton-x.core';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserDisplayNameService {
  constructor(private userProfileService: UserProfileService) {}

  setup(): void {
    this.userProfileService.user$
      .pipe(filter(user => !!user))
      .subscribe(user => {
        const fullName = (user as any)?.fullName?.trim?.() || '';

        if (!fullName) {
          return;
        }

        if (user!.userName === fullName) {
          return;
        }

        this.userProfileService.patchUser({
          userName: fullName,
        });
      });
  }
}

export function initUserDisplayName(): void {
  const service = inject(UserDisplayNameService);
  service.setup();
}

export function provideUserDisplayName(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      initUserDisplayName();
    }),
  ]);
}
